"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const React = __importStar(require("react"));
const ResizeDetectDiv_1 = __importDefault(require("../../core/hoc/ResizeDetectDiv"));
const debounce_1 = require("../../utils/debounce");
class CropContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: this.props.initCollapsed === undefined || this.props.initCollapsed,
            hasOverflow: false,
            fullHeight: ''
        };
        this.setRef = (e) => {
            if (e) {
                this.containerElRef = e;
                this.mutationObserver.observe(e, { childList: true, subtree: true, characterData: true, attributes: true });
                this.computeState();
            }
        };
        //listen for mutations and update accordingly
        const debouncedCompute = (0, debounce_1.debounce)(this.computeState.bind(this), 150);
        this.mutationObserver = new MutationObserver((mutations) => {
            if (mutations === null || mutations === void 0 ? void 0 : mutations.some(mut => mut.type === 'childList' || mut.type === 'characterData' || mut.type === 'attributes')) {
                debouncedCompute();
            }
        });
    }
    onToggle() {
        const { onToggle } = this.props;
        const { collapsed } = this.state;
        const reverseCollapsed = !collapsed;
        this.setState({ collapsed: reverseCollapsed });
        if (onToggle) {
            onToggle(reverseCollapsed, this.containerElRef);
        }
    }
    componentDidMount() {
        // after first render check if component needs toggle
        this.computeState();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.cropHeight !== this.props.cropHeight) {
            this.computeState();
        }
        if ((this.props.collapsed !== undefined) && (this.state.collapsed !== this.props.collapsed)) {
            this.setState({ collapsed: this.props.collapsed });
        }
    }
    componentWillUnmount() {
        this.mutationObserver.disconnect();
    }
    computeState() {
        const nextState = Object.assign({}, this.state);
        if (this.state.collapsed) {
            const hasOverflow = this.containerElRef &&
                this.containerElRef.scrollHeight - this.containerElRef.offsetHeight > 1;
            nextState.hasOverflow = hasOverflow;
        }
        nextState.fullHeight = this.getFullHeight();
        this.setState(nextState);
    }
    getFullHeight() {
        return this.containerElRef && this.containerElRef.scrollHeight ? `${this.containerElRef.scrollHeight}px` : '100%';
    }
    render() {
        const collapsedHeight = `${this.props.cropHeight || '80px'}`;
        const fullHeight = this.state.fullHeight;
        const height = this.state.collapsed
            ? collapsedHeight
            : fullHeight;
        return ((0, jsx_runtime_1.jsxs)(ResizeDetectDiv_1.default, { onWidthChange: this.computeState.bind(this), className: 'tk-crop-content ' + this.props.className, style: this.props.style, children: [(0, jsx_runtime_1.jsx)("div", { ref: this.setRef, className: "content", style: { maxHeight: height }, children: this.props.children }), this.state.hasOverflow ? ((0, jsx_runtime_1.jsx)("div", { className: "toggle-container", children: (0, jsx_runtime_1.jsxs)("a", { onClick: this.onToggle.bind(this), className: "tk-link", children: ["Show ", this.state.collapsed ? 'more' : 'less'] }) })) : null] }));
    }
}
CropContent.defaultProps = {
    cropHeight: '80px',
    initCollapsed: true
};
exports.default = CropContent;
